export default __webpack_public_path__ + "static/media/bmi_tartibi.de3f0e3a.pdf";